/* eslint-disable import/prefer-default-export */
import headers from "app/requests/headers";

export const fixIncorrectStatus = () => (
  fetch("/api/admin/super_admin/fix_incorrect_status", {
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);
